import React, { useEffect } from 'react';
import AuthProvider from '../src/auth/AuthProvider';
import AppRouter from './routers/AppRouter';
import { settings } from './helpers/UtilsHelper';

import '../src/styles.css';

function App() {

  useEffect(() => {
    const themeKey = settings?.localStorage?.theme;
    let savedTheme = localStorage.getItem(themeKey);

    if (!savedTheme) {
      // Check system preference (prefers-color-scheme)
      const systemPrefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches;
      savedTheme = systemPrefersDark ? 'dark' : 'light';
      localStorage.setItem(themeKey, savedTheme); // Save preference on first run
    }

    document.documentElement.setAttribute('data-theme', savedTheme);
  }, []);

  return (
    <AuthProvider>
      
        <div className='wrapper'>
          <AppRouter/>
        </div>
        
    </AuthProvider>
  );
}

export default App;